export function parseCapabilityNumber(
  value: string,
  range: { minimum: number; maximum: number; step?: number }
): number | undefined {
  const trimmed = value.trim();
  const parsed = Number(trimmed);
  if (
    trimmed === "" ||
    !Number.isFinite(parsed) ||
    !Number.isInteger(parsed) ||
    parsed < range.minimum ||
    parsed > range.maximum ||
    (range.step !== undefined && (parsed - range.minimum) % range.step !== 0)
  ) {
    return undefined;
  }
  return parsed;
}
